import type { UserDataFormProps } from './types'

export const initialFormValues: UserDataFormProps = {
  userName: '',
  userCode: '',
  email: '',
  login: '',
  role: '',
  profileDescription: '',
  isAdmin: false
}
